import script from "./MonthPicker.vue?vue&type=script&setup=true&lang=ts"
export * from "./MonthPicker.vue?vue&type=script&setup=true&lang=ts"

import "./MonthPicker.vue?vue&type=style&index=0&id=177b5c99&scoped=true&lang=css"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-177b5c99"]])

export default __exports__